export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/bce1c79c076cfd26ce49a1f2fa85ca50.svg";